import s from './CloseModalButton.module.scss';
import Cross from '@/app/components/ui/icons/Cross';

const CloseModalButton = ({ onClick }) => {
  return (
    <button
      type="button"
      aria-label="Close modal button"
      className={s.closeModalButton}
      onClick={onClick}
    >
      <Cross className={s.closeModalButtonIcon} />
    </button>
  );
};

export default CloseModalButton;
